/**
 * Google Meet URL veya oda kodunu standart `https://meet.google.com/...` formatına dönüştürür.
 */
export function normalizeMeetUrl(input: string): string | null {
  if (!input || !input.trim()) return null;
  let raw = input.trim();

  if (raw.startsWith('http://') || raw.startsWith('https://')) {
    return raw;
  }

  if (raw.includes('meet.google.com')) {
    return `https://${raw}`;
  }

  // Sadece oda kopyalanmışsa (ör. abc-defg-hij)
  return `https://meet.google.com/${raw}`;
}
